import { render, staticRenderFns } from "./eye-close.vue?vue&type=template&id=5c578b5c&"
import script from "./eye-close.vue?vue&type=script&lang=js&"
export * from "./eye-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c578b5c')) {
      api.createRecord('5c578b5c', component.options)
    } else {
      api.reload('5c578b5c', component.options)
    }
    module.hot.accept("./eye-close.vue?vue&type=template&id=5c578b5c&", function () {
      api.rerender('5c578b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/eye-close.vue"
export default component.exports